import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopictwo/GLB_Piso_Sucio_V2.glb";
import gsap from "gsap";

export class DirtyGondolas extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Manchas_2 = gltf.scene.getObjectByName("Manchas_2", true);
			this.Manchas_1 = gltf.scene.getObjectByName("Manchas_1", true);
			this.Latas_3001 = gltf.scene.getObjectByName("Latas_3001", true);
			this.Latas_2001 = gltf.scene.getObjectByName("Latas_2001", true);
			this.Latas_1001 = gltf.scene.getObjectByName("Latas_1001", true);
			this.Cereal_8002 = gltf.scene.getObjectByName("Cereal_8002", true);
			this.Cereal_7002 = gltf.scene.getObjectByName("Cereal_7002", true);
			this.Cereal_6002 = gltf.scene.getObjectByName("Cereal_6002", true);
			this.Cereal_5002 = gltf.scene.getObjectByName("Cereal_5002", true);
			this.Cereal_4002 = gltf.scene.getObjectByName("Cereal_4002", true);
			this.Cereal_3002 = gltf.scene.getObjectByName("Cereal_3002", true);
			this.Cereal_2002 = gltf.scene.getObjectByName("Cereal_2002", true);
			this.Cereal_1002 = gltf.scene.getObjectByName("Cereal_1002", true);
			this.Manchas_2.material = this.newMaterialObject(this.Manchas_2);
			this.Manchas_1.material = this.newMaterialObject(this.Manchas_1);
			this.Latas_3001.material = this.newMaterialObject(this.Latas_3001);
			this.Latas_2001.material = this.newMaterialObject(this.Latas_2001);
			this.Latas_1001.material = this.newMaterialObject(this.Latas_1001);
			this.Cereal_8002.material = this.newMaterialObject(this.Cereal_8002);
			this.Cereal_7002.material = this.newMaterialObject(this.Cereal_7002);
			this.Cereal_6002.material = this.newMaterialObject(this.Cereal_6002);
			this.Cereal_5002.material = this.newMaterialObject(this.Cereal_5002);
			this.Cereal_4002.material = this.newMaterialObject(this.Cereal_4002);
			this.Cereal_3002.material = this.newMaterialObject(this.Cereal_3002);
			this.Cereal_2002.material = this.newMaterialObject(this.Cereal_2002);
			this.Cereal_1002.material = this.newMaterialObject(this.Cereal_1002);
		});
	}

	newMaterialObject(object) {
		const newMaterial = object.material.clone();
		// newMaterial.color.set(0xd1d1d1);
		newMaterial.emissiveIntensity = 1;
		newMaterial.emissive.set("#404040");
		return newMaterial;
	}

	onAnimate(object) {
		if (this.animation) {
			this.animation.kill();
		}
		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	clearAnimation() {
		this.Manchas_2.material.emissiveIntensity = 1
		this.Manchas_1.material.emissiveIntensity = 1
		this.Latas_3001.material.emissiveIntensity = 1
		this.Latas_2001.material.emissiveIntensity = 1
		this.Latas_1001.material.emissiveIntensity = 1
		this.Cereal_8002.material.emissiveIntensity = 1
		this.Cereal_7002.material.emissiveIntensity = 1
		this.Cereal_6002.material.emissiveIntensity = 1
		this.Cereal_5002.material.emissiveIntensity = 1
		this.Cereal_4002.material.emissiveIntensity = 1
		this.Cereal_3002.material.emissiveIntensity = 1
		this.Cereal_2002.material.emissiveIntensity = 1
		this.Cereal_1002.material.emissiveIntensity = 1


		if (this.animationManchas_2) {
			this.animationManchas_2.kill()
			this.animationManchas_2 = null
		}

		if (this.animationManchas_1) {
			this.animationManchas_1.kill()
			this.animationManchas_1 = null
		}
		if (this.animationLatas_3001) {
			this.animationLatas_3001.kill()
			this.animationLatas_3001 = null
		}
		if (this.animationLatas_2001) {
			this.animationLatas_2001.kill()
			this.animationLatas_2001 = null
		}
		if (this.animationLatas_1001) {
			this.animationLatas_1001.kill()
			this.animationLatas_1001 = null
		}
		if (this.animationCereal_8002) {
			this.animationCereal_8002.kill()
			this.animationCereal_8002 = null
		}
		if (this.animationCereal_7002) {
			this.animationCereal_7002.kill()
			this.animationCereal_7002 = null
		}
		if (this.animationCereal_6002) {
			this.animationCereal_6002.kill()
			this.animationCereal_6002 = null
		}
		if (this.animationCereal_5002) {
			this.animationCereal_5002.kill()
			this.animationCereal_5002 = null
		}
		if (this.animationCereal_4002) {
			this.animationCereal_4002.kill()
			this.animationCereal_4002 = null
		}
		if (this.animationCereal_3002) {
			this.animationCereal_3002.kill()
			this.animationCereal_3002 = null
		}
		if (this.animationCereal_2002) {
			this.animationCereal_2002.kill()
			this.animationCereal_2002 = null
		}
		if (this.animationCereal_1002) {
			this.animationCereal_1002.kill()
			this.animationCereal_1002 = null
		}
	}

	onAnimateAll() {
		this.animationManchas_2 = gsap.to(this.Manchas_2.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationManchas_1 = gsap.to(this.Manchas_1.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationLatas_3001 = gsap.to(this.Latas_3001.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationLatas_2001 = gsap.to(this.Latas_2001.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationLatas_1001 = gsap.to(this.Latas_1001.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_8002 = gsap.to(this.Cereal_8002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_7002 = gsap.to(this.Cereal_7002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_6002 = gsap.to(this.Cereal_6002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_5002 = gsap.to(this.Cereal_5002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_4002 = gsap.to(this.Cereal_4002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_3002 = gsap.to(this.Cereal_3002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_2002 = gsap.to(this.Cereal_2002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationCereal_1002 = gsap.to(this.Cereal_1002.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
